<template>
  <v-container class="fill-height addadvertiser" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="12">
        <v-card class="elevation-12">
<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
            <!---- Start Preview ---->
            <v-row align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
            <div class="row justify-content-center border ">
              <table width="60%" align="center" style="margin:0 auto; border:1px solid #b3d4fc;">
                <tr>
                  <td colspan="3">
                      <div class="header-content headecontent padding-right-0">
                            <img width="100%" height="100%"  :src="topheader" >
                      </div>  
                    </td>  
                </tr>
                <tr>
                    <td colspan="3">
                   <div class="col-lg-12 col-md-12 padding-right-0 left-content">
                      <div style="margin:0 auto;" class="bannercontenthtml bannercontentimage" v-html="bannercontent">
                      </div>
                   </div>
                  </td>
                 </tr>
                 <tr>
                   <td colspan="3" >
                         <div class="col-lg-12 col-md-12 padding-right-0 left-content">
                            <img  width="100%" :src="footerbanner" >
                          </div>    
                    </td>  
                </tr>  
            </table>   
            </div>
            </v-col>
        </v-row>
      <!---- End Preview ---->
      </v-col>
    </v-row>
  </v-container>
  </template>
  </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import 'vue-form-wizard/dist/vue-form-wizard.min.css'

//var adserverURL ="http://local.adserver.com/www/";

  export default {
    name: 'Pi3cktemplate',
    props:[
       'bannerposition',
       'bannercontentimage',
       'bannercontenthtml',
       'bannercontent',
       'bannerimage',
    ],
    components: {
         
        },
    data: () => ({
      topheader : require("@/assets/droadheader.jpg"),
      footerbanner : require("@/assets/droadfooter.jpg"),


      headersection : require("@/assets/mynews24-header.png"),
     // leftsection : require("@/assets/mynews24-middle.png"),
     middlesection:  require("@/assets/mynews24-middle.png"),
      rightsection :  require("@/assets/mynews24-footer.png"),
      adhere: require("@/assets/506.jpg"),
     }),
      mounted() {
       
     },
   computed:{
     baseURL() {
              const url = process.env.VUE_APP_BASEAPI.slice(0, -4);
              return url;
            }
     },
    methods: { 
        
    }
  }
</script>
<style scoped>
.row {
  margin-left: 0px;
}
.headecontent {height: 100px;}
.padding-top-0{padding-top: 0px !important;}
.padding-right-0{padding-right: 0px !important;}
.padding-bottom-0{padding-bottom: 0px !important;}    
.draggable-list {
  color: #fff;
  border: 1px solid;
  height: 150px;
}
.header-content{width:100%;}
.left-content{padding-top:0px;padding-right:0px; }
.center-content{height: 100%;}
.right-content{height: 100%;}
.footer-content{height: 100%; border:1px solid #b3d4fc;}
.draggablecontent{background-size: 100% 100%;margin-top: 24%;width: 50%;margin-left: 25%;}
.bannercontentimage{width:250px;height:250px;position: relative;}

.postionsection{width: 100%;height: 150px;}
.leftsection{padding-bottom:16px;}
</style>